import { type SxProps, Typography, type TypographyProps } from '@mui/material';
import type { ReactNode } from 'react';

type HeadlineSize = 'lg' | 'sm';

// Map sizes to theme typography variants
const variantMap: Record<HeadlineSize, TypographyProps['variant']> = {
  lg: 'h1', // 32px, 700 weight - Display/hero
  sm: 'h3', // 20px, 600 weight - Major sections
};

interface Props {
  children: ReactNode;
  size: HeadlineSize;
  sx?: SxProps;
  component?: any;
}

export default function Headline({ children, size, component, sx }: Props) {
  return (
    <Typography
      variant={variantMap[size]}
      sx={sx}
      component={component}
    >
      {children}
    </Typography>
  );
}
